<template>
  <div class='app-cookie' v-if='!cookieAccepted'>
    <div class='text'>
      {{ $t('cookie-bar.text') }}
      <router-link class='cgu-link' :to='{ name: "cgu" }' target='_blank'>
        {{ $t('cookie-bar.link') }}
      </router-link>
    </div>
    <x-button @click='acceptCookie' class='md-raised outline'>{{ $t('cookie-bar.button') }}</x-button>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'app-cookie',
    computed: {
      ...mapState({
        cookieAccepted: ({ cookieAccepted }) => cookieAccepted
      })
    },
    methods: {
      ...mapMutations({
        acceptCookie: 'acceptCookie'
      })
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .app-cookie {
    z-index: 99;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: map_get($palette-primary, main);
    color: white;
    padding: $space-small $space-big;
    display: flex;
    align-items: center;
    justify-content: center;

    .cgu-link {
      text-decoration: underline;
      font-weight: 600;
    }

    .button {
      color: map_get($palette-primary, text) !important;
      border-color: map_get($palette-primary, text) !important;
      background-color: transparent !important;
      margin-left: $space-medium;
      transition: all 300ms;
    }
  }
</style>
